import React, { Component } from 'react'
import { Button, Col } from 'reactstrap';
import InfoRow from '../InfoRow';
import T from 'i18n-react';

class Welcome extends Component {

  constructor(props) {
    super(props);
  }

  onSettingsClick = () => {
    const { router } = this.context;
    router.history.push('/settings');
  }

  render() {
      return(

  <div className="col-sm-12">
    <h4 className="title-screen">
      <T.text tag='span' text="welcome"/>
    </h4>
    <br/>
    <div className="row">
      <div className="col">
        <Button color="warning"
                className="curr-pointer wlc-btn"
                onClick={this.onSettingsClick}>
                  <T.text tag='span' text="settings"/>
                </Button>
      </div>

      <div className="col">
        <Button color="warning"
                className="curr-pointer wlc-btn"
                onClick={()=> {this.props.history.push('/topUpEwallet')}}>
                  <T.text tag='span' text="menu_top_up_wallet"/>
              </Button>
      </div>

      <div className="col">
        <Button color="warning"
                className="curr-pointer wlc-btn"
                onClick={()=> {this.props.history.push('/history')}}>
                  <T.text tag='span' text="trn_history"/>
                </Button>
      </div>
    </div>

  </div>

    )
  }
}

Welcome.contextTypes = {
  router: React.PropTypes.object
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/components/welcome/Welcome.js